export class AppConfig {

   //public readonly apiUrl = 'http://10.79.208.103:10620/API';
   public readonly apiUrl = './API';
}



// WEBPACK FOOTER //
// /app/src/app/app.config.ts